import axios from 'axios'// 引入axios
import env from './env'
// import Vue from 'vue'
import { Toast } from 'vant';
import { Promise } from 'core-js'
import qs from 'qs'
// 创建axios实例
const service = axios.create({
  // 这里拿线上接口测试
  baseURL: env.baseIP,
  headers: { // 请求头
    'Content-Type': 'application/json;charset=UTF-8;'
  },
  timeout: 10000 // 超时时间
})
// 请求拦截器
service.interceptors.request.use(
  config => {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁止背景点击
      message: '加载中...'
    })
    if (localStorage.getItem('TOKEN')) {
      config.headers.authorization = localStorage.getItem('TOKEN')
    }
    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    return config // 记得一定要 返回config
  },
  error => {
    Toast.clear()
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use((res) => {
  Toast.clear()
  if (res.status && res.status === 200) {
    if (res.headers && res.headers.authorization) {
      const authorization = res.headers.authorization
      localStorage.setItem('TOKEN', authorization)
    }
    if (res.data.code === 200) {
      return res.data
    } else if (res.data.code === 401) {
      Toast.fail('登录已过期，请重新登录！')
      localStorage.removeItem('TOKEN') // 移除token，跳转至登录
      // setTimeout(() => {
      //   router.push({
      //     path: '/', //登录过期
      //     params: {
      //       pushUrl: ''
      //     }
      //   })
      // }, 1000)
      
    } else {
      Toast.fail(res.data.msg)
    }
    return Promise.reject(res)
  }
}, err => {
  Toast.clear()
  console.log('err', err)
  if (err.status === 401) {
    Toast.fail('登录已过期，请重新登录！')
    localStorage.removeItem('TOKEN') // 移除token，跳转至登录
    // setTimeout(() => {
    //   router.push({
    //     path: '/', //登录过期
    //     params: {
    //       pushUrl: ''
    //     }
    //   })
    // }, 1000)
  } else {
    Toast.fail('无服务，请稍后重试！')
  }
  return Promise.reject(err)
})
export default service
